import { useQuery } from "@tanstack/react-query";

import { getPickZoneConfigurationHistory } from "@/api/audit-configuration-history-api";
import { type AuditRecord } from "@/components/diff-view";

export const PICK_ZONE_CONFIGURATION_HISTORY_QUERY_KEY = "pick-zones-configuration-history";

export const usePickZoneConfigurationHistory = (id: string, enabled: boolean) => {
	return useQuery<AuditRecord[]>({
		queryKey: [PICK_ZONE_CONFIGURATION_HISTORY_QUERY_KEY, id],
		queryFn: () => getPickZoneConfigurationHistory(id),
		initialData: [],
		retry: false,
		enabled,
	});
};
